/// <amd-module name="Environments/EnvironmentRunDetails/ActionsCreators/JobsActionsCreator" />
import { ActionCreatorBase } from "Environments/Flux/ActionCreatorBase";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { JobsActions } from "Environments/EnvironmentRunDetails/Actions/JobsActions";
import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";

import { IEnvironmentDeploymentHistoryService } from "Environments/Client/EnvironmentDeploymentHistoryService";
import { EnvironmentStageDeploymentData } from "Environments/RemoteClients/Contracts/Traceability";

import { IVssPageContext } from "VSS/Platform/Context";

const JobsView: string = "environments";

export class JobsActionsCreator extends ActionCreatorBase {

    public static getKey(): string {
        return "env-deployments-job-history-action-creator";
    }

    public initialize(instanceId?: string) {
        super.initialize(instanceId);
        
        this._actions = ActionsHubManager.CreateActionsHub<JobsActions>(JobsActions, instanceId);
        this._messageActions = ActionsHubManager.CreateActionsHub<MessagesActions>(MessagesActions, instanceId);
    }

    public getJobs(pageContext: IVssPageContext, environmentId: number, environmentExecutionRecordId: number): boolean {

        const historyService = pageContext.getService<IEnvironmentDeploymentHistoryService>("IEnvironmentDeploymentHistoryService");
        const stageDeploymentData: EnvironmentStageDeploymentData | undefined = historyService.getEnvironmentStageJobs(environmentId, environmentExecutionRecordId);

        if (stageDeploymentData) {
            this._actions.setDeploymentJobs.invoke(stageDeploymentData);
            return true;
        }

        const stageDeploymentDataPromise = historyService.getEnvironmentStageJobsAsync(environmentId, environmentExecutionRecordId);

        stageDeploymentDataPromise.then((data: EnvironmentStageDeploymentData) => {
            this._actions.setDeploymentJobs.invoke(data);
        })
        .catch((error) => {
            this._messageActions.addMessage.invoke({ key: JobsView, value: error })
        });

        return false;
    }

    protected disposeInternal(): void {
        ActionsHubManager.DeleteActionsHub<JobsActions>(JobsActions, this.getInstanceId());
        ActionsHubManager.DeleteActionsHub<MessagesActions>(MessagesActions, this.getInstanceId());
    }

    private _actions: JobsActions;
    private _messageActions: MessagesActions;
}
